<!--
 * @Description: 首页文件根组件
 * @Author: 王振
 * @Date: 2021-05-28 14:52:04
 * @LastEditors: 王振
 * @LastEditTime: 2021-07-07 08:54:03
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "system",
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/system/system.vue